<template>
  <v-row v-if="team.content_enabled || team.sharing_enabled">
    <v-col cols="12"
           sm="6">
      <div class="overline">
        A Mobile Locker user
      </div>
      <v-switch v-model="form.settings.can_be_presented_by_user"
                hide-details
                :label="can(form.settings.can_be_presented_by_user, 'present this file from the browser.')">
      </v-switch>

      <v-switch v-model="form.settings.can_be_shared"
                hide-details
                :label="can(form.settings.can_be_shared, 'share this file via email.')">
      </v-switch>

      <v-switch v-model="form.settings.can_be_shared_link"
                hide-details
                :label="can(form.settings.can_be_shared_link, 'create a link to this file.')">
      </v-switch>

      <v-switch v-model="form.settings.can_be_used_in_builder"
                hide-details
                :label="can(form.settings.can_be_used_in_builder, 'use this file in the presentation builder.')">
      </v-switch>

      <v-switch v-model="form.settings.can_be_exported"
                v-if="team.content_enabled"
                hide-details
                :label="can(form.settings.can_be_exported, 'export this file out of Mobile Locker.')">
      </v-switch>

      <v-switch v-model="form.settings.can_be_printed_by_user"
                v-if="team.content_enabled"
                hide-details
                :label="can(form.settings.can_be_printed_by_user, 'print this file from the browser or desktop app.')">
      </v-switch>

      <v-switch v-model="form.settings.can_be_annotated"
                v-if="team.content_enabled"
                hide-details
                :label="can(form.settings.can_be_annotated, 'annotate this file in the iOS app.')">
      </v-switch>

      <v-switch v-model="form.is_rateable"
                v-if="team.ai_enabled"
                hide-details
                :label="can(form.is_rateable, 'provide feedback on this file in the iOS app.')">
      </v-switch>
    </v-col>

    <v-col cols="12"
           sm="6"
           v-if="form.settings.can_be_shared || form.settings.can_be_shared_link">
      <div class="overline">
        A recipient
      </div>
      <v-switch v-model="form.settings.can_be_downloaded"
                hide-details
                :label="can(form.settings.can_be_downloaded, 'download this file to their computer.')">
      </v-switch>
      <v-switch v-model="form.settings.can_be_printed"
                hide-details
                :label="can(form.settings.can_be_printed, 'print this file.')">
      </v-switch>
      <v-switch v-model="form.settings.can_be_forwarded"
                hide-details
                :label="can(form.settings.can_be_forwarded, 'forward the file to someone else.')">
      </v-switch>
    </v-col>
  </v-row>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    presentation: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
  },
  created() {
    this.fetchData();
  },
  methods: {
    can(flag, label) { // MLD-2254
      if (flag) {
        return `Can ${label}`;
      } else {
        return `Cannot ${label}`;
      }
    },
    fetchData() {

    },
  }
}
</script>
